// src/VisualizadorPDF.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  isMobile,
  isTablet,
  isSmartTV,
  isBrowser,
} from 'react-device-detect';
import BottomNav from './BottomNav';
import TopBarYou from './TopBarYou';
import SidebarYou from './SidebarYou';
import PDFViewer from './components/PDFViewer';

const VisualizadorPDF = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const url = params.get('url');

  // Recupera nome do usuário via token
  let nomeUsuario = "Usuário";
  try {
    const token = sessionStorage.getItem("KEY_APP_BGG");
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]));
      nomeUsuario = payload[0]?.nome || "Usuário";
    }
  } catch (err) {
    console.warn("Erro ao recuperar nome do usuário via token:", err);
  }

  if (!url) return <div className="p-4">PDF não encontrado ou URL inválida.</div>;

  return (
    <div className="dashboard-you min-h-screen dark-mode">
      {!(isMobile || isTablet) && <TopBarYou />}
      {(isBrowser || isSmartTV) && <SidebarYou />}

      <div
        className="dashboard-content"
        style={{
          paddingTop: !(isMobile || isTablet) ? '70px' : '0px',
          marginLeft: isBrowser || isSmartTV ? '65px' : '0',
          transition: 'margin-left 0.3s ease',
          height: 'calc(100vh - 70px)',
          overflow: 'auto',
        }}
      >
        <PDFViewer url={url} nomeUsuario={nomeUsuario} />
      </div>

      {(isMobile || isTablet) && <BottomNav />}
    </div>
  );
};

export default VisualizadorPDF;
